import React from "react";
import styles from "./MultiToggleWidget.module.scss";
import { withTranslation } from "react-i18next";

const MultiToggleWidget = (props) => {
  let acceptedText, rejectedText, acceptedStyle, rejectedStyle;
  const toggleDisabled = props.isToggleDisabled && `${styles.toggleDisabled}`;
  const switchStyle = props.fromDealerTable
    ? styles.switchToggleSmall
    : styles.switchToggle;
  const toggleLabelStyle = props.fromDealerTable
    ? styles.toggleLabelSmall
    : styles.toggleLabel;
  const toggleInputStyle = props.fromDealerTable
    ? styles.toggleInputSmall
    : styles.toggleInput;

  if (props.currentStatus === "yes") {
    acceptedText = props.settings.acceptedText;
    rejectedText = "";
    acceptedStyle = toggleLabelStyle + " " + props.settings.toggleLabel;
    rejectedStyle = styles.switchLabel;
  } else if (props.currentStatus === "no") {
    acceptedText = "";
    rejectedText = props.settings.rejectedText;
    acceptedStyle = styles.switchLabel;
    rejectedStyle = toggleLabelStyle + " " + props.settings.toggleLabel;
  }

  return toggleDisabled ? (
    <div
      className={`${styles.toggleLabel} ${props.settings.suppClass}`}
      id={`disabled_${props.toggleName}`}
      data-testid={`disabled_${props.toggleName}`}
    >
      <div className={`${styles.labelYes}`}>{acceptedText}</div>
      <div className={`${styles.labelNo}`}>{rejectedText}</div>
    </div>
  ) : (
    <div
      className={`${props.settings.suppClass} ${switchStyle} ${toggleDisabled} switch-2 switch-candy`}
    >
      <input
        className={toggleInputStyle}
        id={`${props.toggleName}`}
        data-testid={`${props.toggleName}`}
        disabled={props.isToggleDisabled}
        name={`${props.toggleName}`}
        type="checkbox"
        value="yes"
        onChange={(e) => props.onSelect(e)}
        checked={props.currentStatus === "yes"}
      />
      <label htmlFor={`${props.toggleName}`}>
        <div className={`${acceptedStyle} ${styles.labelYes}`}>
          {acceptedText}
        </div>
        <div className={`${rejectedStyle} ${styles.labelNo}`}>
          {rejectedText}
        </div>
      </label>
    </div>
  );
};

export default withTranslation("emp")(MultiToggleWidget);
